import { render, staticRenderFns } from "./FreeVideoView.vue?vue&type=template&id=95cf2f12"
import script from "./FreeVideoView.vue?vue&type=script&lang=js"
export * from "./FreeVideoView.vue?vue&type=script&lang=js"
import style0 from "./FreeVideoView.vue?vue&type=style&index=0&id=95cf2f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports